export const tr = {
  // Common UI elements
  common: {
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    add: "Ekle",
    search: "Ara",
    loading: "Yükleniyor",
    noRecords: "Kayıt Bulunamadı",
    submit: "Gönder",
    submitting: "Gönderiliyor...",
    saving: "Kaydediliyor...",
    creating: "Oluşturuluyor...",
    deleting: "Siliniyor...",
    create: "Oluştur",
    actions: "İşlemler",
    active: "Aktif",
    inactive: "Pasif",
    status: "Durum",
    back: "Geri",
    next: "İleri",
    previous: "Önceki",
    close: "Kapat",
    open: "Aç",
    yes: "Evet",
    no: "Hayır",
    confirm: "Onayla",
    language: "Dil",
    error: "Hata",
    profile: "Profil",
    details: "Detaylar",
    country: "Ülke",
    title: "Başlık",
    description: "Açıklama",
    optional: "İsteğe bağlı",
    total: "Toplam",
    price: "Fiyat",
    quantity: "Miktar",
    continue: "Devam Et",
    finish: "Bitir",
    skip: "Atla",
    completed: "Tamamlandı",
    required: "Zorunlu",
    free: "Ücretsiz",
    info: "Bilgi",
    noImage: "Resim Yok",
  },

  // Status values (order, fulfilment, payment, withdrawal, etc.) – use with getStatusTranslation
  statuses: {
    order: {
      pending: "Beklemede",
      processing: "İşleniyor",
      shipped: "Kargoya Verildi",
      delivered: "Teslim Edildi",
      cancelled: "İptal Edildi",
      confirmed: "Onaylandı",
      in_progress: "İşlemde",
      pending_approval: "Onay Bekliyor",
      unfulfilled: "Tamamlanmadı",
      fulfilled: "Tamamlandı",
      waiting_for_delivery: "Teslimat Bekleniyor",
      waiting_for_payment: "Ödeme Bekleniyor",
      fraud_check: "Dolandırıcılık Kontrolü",
      completed: "Tamamlandı",
    },
    fulfilment: {
      fulfilled: "Tamamlandı",
      not_fulfilled: "Tamamlanmadı",
      unfulfilled: "Tamamlanmadı",
      partial: "Kısmen Tamamlandı",
      shipped: "Kargoya Verildi",
      waiting_for_delivery: "Teslimat Bekleniyor",
      waiting_for_payment: "Ödeme Bekleniyor",
      fraud_check: "Dolandırıcılık Kontrolü",
      completed: "Tamamlandı",
    },
    refund: {
      completed: "Tamamlandı",
      approved: "Onaylandı",
      pending: "Beklemede",
      processing: "İşleniyor",
      in_progress: "İşlemde",
      initiated: "Başlatıldı",
      rejected: "Reddedildi",
      failed: "Başarısız",
      cancelled: "İptal Edildi",
      error: "Hata",
    },
    withdrawal: {
      approved: "Onaylandı",
      created: "Beklemede",
      rejected: "Reddedildi",
    },
    transaction: {
      captured: "Alındı",
      pending: "Beklemede",
      authorized: "Yetkilendirildi",
      refunded: "İade Edildi",
      failed: "Başarısız",
      cancelled: "İptal Edildi",
      requires_action: "İşlem Gerekli",
    },
    streamer: {
      approved: "Onaylandı",
      pending: "Beklemede",
      rejected: "Reddedildi",
    },
    lottery: {
      active: "Aktif",
      completed: "Tamamlandı",
      cancelled: "İptal Edildi",
      waiting_for_approval: "Onay Bekliyor",
    },
  },

  bankDetails: {
    book: {
      description:
        "Banka bilgilerinizi görüntüleyin ve güncelleyin, dilediğiniz kadar ekleyebilirsiniz. Kaydettiğiniz banka bilgileri çekim işlemlerinde kullanılabilir olur.",
      noAddress:
        "Henüz teslimat adresiniz bulunmamaktadır. Lütfen adres ekleyiniz.",
      noBankDetails:
        "Henüz banka bilginiz bulunmamaktadır. Lütfen banka bilgilerinizi ekleyin.",
    },
    page: {
      title: "Banka Detayları",
      description: "Banka bilgilerinizi görüntüleyin",
    },
  },
  address: {
    book: {
      description:
        "Teslimat adreslerinizi görüntüleyin ve güncelleyin, dilediğiniz kadar ekleyebilirsiniz. Kaydettiğiniz adresler ödeme sırasında kullanılabilir.",
      noAddress:
        "Henüz teslimat adresiniz bulunmamaktadır. Lütfen adres ekleyiniz.",
    },
  },
  cartTotals: {
    subtotal: "Ara toplam (kargo ve vergiler hariç)",
    discount: "İndirim",
    total: "Toplam",
  },
  cartDropdown: {
    title: "Sepet",
    variant: "Varyant",
    quantity: "Adet",
    unitPrice: "Birim Fiyat",
    unitTypes: {
      Piece: "Adet",
      KG: "KG",
      Ton: "Ton",
      Meter: "Metre",
      "m²": "m²",
    },
    noExtraInfo: "Ekstra bilgi yok",
    subtotal: "Ara Toplam",
    subtotalNote: "(vergiler hariç)",
    remainingToPay: "Ödenecek Kalan",
    goToCart: "Sepete git",
    empty: "Alışveriş çantanız boş.",
    exploreProducts: "Ürünleri keşfet",
    exploreProductsSr: "Tüm ürünler sayfasına git",
  },

  // Navigation
  navigation: {
    home: "Ana Sayfa",
    categories: "Kategoriler",
    products: "Ürünler",
    cart: "Sepet",
    account: "Hesap",
    orders: "Siparişler",
    checkout: "Ödeme",
    search: "Ara",
    menu: "Menü",
    close: "Kapat",
  },

  // Promotion
  promotion: {
    copy: "Kopyala",
    copiedToClipboard: "Panoya kopyalandı",
    dontShowAgain: "Tekrar gösterme",
    closePopup: "Pop-up'ı kapat",
  },

  // Home
  home: {
    discoverAll: "TÜMÜNÜ KEŞFET",
    popularGames: "POPULER URUNLER",
    homeProducts: "Anasayfa Ürünleri",
    allCategories: "Tüm Kategoriler",
    discounted: "İndirimli",
    discountPercent: "%{{percent}} İndirim",
    productBeingSupplied: "Ürün tedarik ediliyor.",
  },

  blog: {
    brand: "101yapi Blog",
    heroTitle: "Yapı malzemeleri, uygulama rehberleri ve proje fikirleri",
    heroDescription:
      "Ürün seçimi, montaj ipuçları, malzeme karşılaştırmaları ve bölgesel proje rehberleriyle 101yapi ürün sayfalarını destekleyen bilgi merkezi.",
    searchPlaceholder: "Blog yazılarında ara",
    clearFilters: "Filtreleri temizle",
    postsShowing: "{{count}} blog yazısı gösteriliyor",
    featured: "Öne çıkan",
    readArticle: "Yazıyı oku",
    read: "Oku",
    noPosts: "Seçilen filtrelere uygun blog yazısı bulunamadı.",
    categories: "Kategoriler",
    tags: "Etiketler",
    readTime: "{{count}} dk",
    backToBlog: "Blog'a dön",
    author: "Yazar",
    content: "İçerik",
    relatedProducts: "İlgili ürünler",
    relatedCategories: "İlgili kategoriler",
    recommendedWithArticle: "Yazıyla birlikte önerilenler",
    linkedProducts: "Bağlı ürünler",
    linkedProductsDescription:
      "Okuduğunuz içerikle doğrudan ilişkili ürünler. Detaylara gidip stok ve özelliklere hemen bakabilirsiniz.",
    discountPercent: "%{{percent}} indirim",
    noPrice: "Fiyat bilgisi yok",
    goToProduct: "Ürüne git",
    relatedPosts: "İlgili yazılar",
  },

  // Cart
  cart: {
    title: "Sepet",
    empty: "Sepetiniz boş",
    emptyDescription: "Alışverişe başlamak için ürün ekleyin",
    item: "Ürün",
    quantity: "Adet",
    price: "Fiyat",
    subtotal: "Ara Toplam",
    total: "Toplam",
    checkout: "Ödemeye Geç",
    remove: "Kaldır",
    clear: "Sepeti Temizle",
    continueShopping: "Alışverişe Devam Et",
    emptyTitle: "Sepetiniz boş!",
    emptyMessage:
      "Sepetinizi 101yapi'in ürünleri ve fırsatlarıyla doldurmak için şimdi ürünlerimizi keşfetmeye başlayabilirsiniz.",
    continueShoppingButton: "Alışverişe Devam Et",
    priceChangesDetected: "Fiyat Değişiklikleri Tespit Edildi",
    priceChangesDescription:
      "Sepetinizdeki bazı ürünlerin fiyatları güncellendi. Lütfen aşağıdaki değişiklikleri inceleyin.",
    priceIncreases: "Fiyat Artışları",
    priceDecreases: "Fiyat Düşüşleri",
    continueWithUpdatedPrices: "Güncellenmiş Fiyatlarla Devam Et",
    variantUndefined: "Varyant tanımsız",
    productTitle: "Ürün başlığı",
    productImage: "Ürün görseli",
    promoCode: "Promosyon Kodu",
    off: "indirim",
    availableProducts: "mevcut ürünler",
    basket: "sepet",
    apply: "Uygula",
    applying: "Uygulanıyor...",
    applied: "Uygulandı",
    minimumOrderValue: "Minimum sipariş tutarı",
    select: "Seç...",
    yourCart: "Sepetiniz",
    items: "ürün",
    failedToUpdateCart: "Sepet güncellenemedi",
    updatingQuantity: "Miktar güncelleniyor...",
    quantityUpdated: "Miktar güncellendi!",
    failedToUpdateQuantity: "Miktar güncellenemedi.",
    noMoreStockAvailable:
      "Bu ürün için yeterli stok bulunmamaktadır. Bu nedenle miktarı daha fazla artıramazsınız.",
    failedToDecreaseQuantity: "Miktar azaltılamadı. Lütfen tekrar deneyin.",
    itemRemoved: "Ürün sepetten kaldırıldı",
    failedToRemoveItem: "Ürün sepetten kaldırılamadı",
    couponAppliedSuccess: "Kupon başarıyla uygulandı",
    couponNotValid: "Bu kupon sepetinizdeki hiçbir ürün için geçerli değil",
    invalidCouponCode: "Geçersiz kupon kodu",
    couponAlreadyUsed:
      "Bu kuponu zaten kullandınız. Her kupon müşteri başına yalnızca bir kez kullanılabilir.",
    couponNotAvailableForGroup:
      "Bu kupon müşteri grubunuz için mevcut değildir.",
    minimumOrderNotMet:
      "Sipariş tutarınız bu kupon için minimum gereksinimi karşılamıyor.",
    discountsCannotBeApplied: "İndirimler sepetinizdeki ürünlere uygulanamaz.",
    unitPrice: "Birim Fiyat",
    totalPrice: "Toplam Fiyat",
    cartItems: "Sepet Öğeleri",
    seller: "Satıcı",
    noExtraInfo: "Ekstra bilgi yok",
    promotionNotApplicable: "Promosyon Uygulanamaz",
    applyCoupon: "Kupon Uygula",
    enterCouponCode: "Kupon kodunu girin",
    availablePromotions: "Mevcut Promosyonlar",
    cartSummary: "Sepet Özeti",
    tax: "Vergi",
    commission: "Komisyon",
    shipping: "Kargo",
    shippingAdjustments: "Kargo Düzenlemeleri",
    totalAmount: "Toplam Tutar",
    discount: "İndirim",
    walletPaymentAmount: "Cüzdan Ödeme Tutarı",
    remainingToPay: "Ödenecek Kalan",
    completeCheckout: "Siparişi Tamamla",
    signIn: "Giriş Yap",
    termsAgreement:
      "Devam ederek Kullanım Koşullarımızı ve Gizlilik Politikamızı kabul etmiş olursunuz",
    needHelp: "Yardıma mı ihtiyacınız var?",
    customerServiceAvailable:
      "Müşteri hizmetlerimiz ekibimiz herhangi bir sorunuz için 7/24 hizmetinizdedir.",
    contactSupport: "Destek ile İletişime Geç",
    removeItem: "Ürünü Kaldır",
    removeItemConfirm:
      "Bu ürünü sepetinizden kaldırmak istediğinizden emin misiniz?",
    cancel: "İptal",
    loginRequired: "Giriş Gerekli",
    loginRequiredForCoupons:
      "İndirim kuponlarını kullanmak için lütfen hesabınıza giriş yapın.",
    close: "Kapat",
    cartUpdateRequired: "Sepet Güncellemesi Gerekli",
    partialPaymentDetected:
      "Kısmi cüzdan ödemesi tespit edildi. Güvenli bir ödeme için önceki sepetiniz korunmuştur. Lütfen misafir sepetinizi temizleyin veya mevcut öğelerinizle devam edin.",
    clearGuestCart: "Misafir Sepetini Temizle",
    continueWithCurrentCart: "Mevcut Sepetle Devam Et",
    guestCartCleared: "Misafir sepeti başarıyla temizlendi!",
    yourCartIsEmpty: "Sepetiniz boş",
    looksLikeEmpty: "Görünüşe göre henüz sepetinize bir şey eklemediniz.",
    startShopping: "Alışverişe Başla",
    digitalProductsNotice:
      "Sepetinizde fiziksel urunler bulunuyor. Teslimat adresinize standart kargo ile gonderilecektir.",
    promotionsApplied: "Uygulanan promosyon(lar):",
    removePromotionSr: "Promosyonu siparişten kaldır",
  },

  // Product
  product: {
    addToCart: "Sepete Ekle",
    addingToCart: "Ekleniyor...",
    calculate: "Hesapla",
    width: "Genişlik (cm)",
    length: "Uzunluk (cm)",
    thickness: "Kalınlık (cm)",
    quantity: "Adet",
    area: "Kapatmak istediğiniz alanı girin (m²)",
    recommendedPieces: "10% fire payı dahil önerilen miktar: {{count}} adet",
    recommendedArea: "10% fire payı dahil önerilen miktar: {{count}} m²",
    dimensionsInstruction:
      "Lütfen boyutları santimetre (cm) cinsinden giriniz.",
    totalArea: "Toplam Alan (m²)",
    recommendedPackages: "Önerilen Paket Sayısı",
    viewDetails: "Detayı Gör",
    buyNow: "Hemen Satın Al",
    outOfStock: "Stokta Yok",
    inStock: "Stokta Var",
    description: "Açıklama",
    specifications: "Özellikler",
    reviews: "Yorumlar",
    relatedProducts: "Benzer Ürünler",
    // Product Tabs
    productDescription: "Ürün Açıklaması",
    campaigns: "Kampanyalar",
    reviewsCount: "Yorumlar ({{count}})",
    refundPolicy: "İade Politikası",
    ageRestrictions: "Yaş Kısıtlamaları",
    systemRequirements: "Sistem Gereksinimleri",
    howToUse: "Nasıl Kullanılır",
    platforms: "Platformlar",
    regions: "Bölgeler",
    supportedPlatforms: "Desteklenen Platformlar",
    availableRegions: "Mevcut Bölgeler",
    noPlatformInfo: "Platform bilgisi mevcut değil.",
    noRegionInfo: "Bölge bilgisi mevcut değil.",
    ageClassificationSystem: "Yaş sınıflandırma sistemi",
    noSpecificAgeRestrictions: "Belirli yaş kısıtlaması yok",
    noAgeRestrictionInfo: "Yaş kısıtlama bilgisi mevcut değil.",
    noSystemRequirements: "Sistem gereksinimleri mevcut değil.",
    noHowToInfo: "Kullanım bilgisi mevcut değil.",
    noRefundPolicyInfo: "İade politikası bilgisi mevcut değil.",
    noSeoData: "SEO verisi yok.",
    metaTitle: "Meta Başlık",
    metaDescription: "Meta Açıklama",
    metaKeywords: "Meta Anahtar Kelimeler",
    seoContent: "SEO İçeriği",
    anonymous: "Anonim",
    mustPurchaseToReview:
      "Yorum yapabilmek için önce ürünü satın almanız gerekmektedir.",
    youMightAlsoLike: "Bu ürünlere de göz atmak isteyebilirsiniz.",
    price: "Fiyat",
    noStockAvailable: "Bu ürün için stok bulunmamaktadır",
    addToCartFailed: "Ürün sepete eklenemedi. Lütfen tekrar deneyin.",
    variantRequiredGoToDetails:
      "Bu ürün için seçenek gerekli, önce detay sayfasına gidin.",
    off: "% İNDİRİM",
    productBeingSupplied: "Ürün Tedarik Ediliyor",
    epinDeliveryInfo: "Urun stok durumuna gore hazirlanir ve sevk edilir.",
    notEligibleForPromotion:
      "Bu ürün promosyon kodu veya indirim için uygun değildir.",
    partialPaymentWarning:
      "Kısmi ödemeli bir sepetiniz var. Daha fazla ürün eklemeden önce mevcut siparişinizi tamamlayın.",
    decreaseQuantity: "Miktarı azalt",
    increaseQuantity: "Miktarı artır",
    quantityLabel: "Miktar",
    maxQuantityReached: "Bu ürün için maksimum miktara ulaştınız",
    completeCurrentOrder: "Mevcut Siparişi Tamamla",
    selectVariant: "Varyant Seç",
    productImage: "Ürün görseli",
    promotionNotApplicable: "Promosyon Uygulanamaz",
    comments: "Yorum",
    rateProduct: "Ürünü Değerlendir",
    addToFavorites: "Favorilere Ekle",
    removeFromFavorites: "Favorilerden Çıkar",
    favoriteAddedSuccess: "Ürün favorilere eklendi!",
    favoriteRemovedSuccess: "Ürün favorilerden çıkarıldı.",
    favoriteError: "Favoriler güncellenirken bir hata oluştu.",
    favoriteAuthRequired: "Favorilere eklemek için lütfen giriş yapın.",
    noVariantSelected: "Lütfen bir ürün varyantı seçin.",
    favorites: "Favoriler",
    favoritesDescription:
      "Burada favori ürünlerinizi görüntüleyebilir ve yönetebilirsiniz.",
    noFavoritesYet: "Henüz favori ürününüz yok.",
    noFavoritesDescription:
      "Sevdiğiniz ürünleri daha sonra kolayca bulmak için favorilerinize ekleyin.",
    browseProducts: "Ürünlere Göz At",
    noImage: "Resim Yok",
    moreFromCategory: "Bu kategoriden daha fazla",
    discoverMoreProducts: "Aynı kategorideki diğer ürünleri keşfedin",
    canActivateIn: "Etkinleştirilebilir",
    region: "Bölge",
    platform: "Platform",
    type: "Tip",
    topUp: "Yükleme",
    notSpecified: "Belirtilmemiş",
    rating: "Değerlendirme",
    rateStars: "{{count}} yıldız ver",
    yourReview: "Yorumunuz",
    reviewPlaceholder: "Bu ürün hakkında ne beğendiniz veya beğenmediniz?",
    submitting: "Gönderiliyor...",
    submitReview: "Yorumu Gönder",
    reviewSubmittedSuccess: "Yorum başarıyla gönderildi!",
    reviewError: "Bir şeyler yanlış gitti. Lütfen tekrar deneyin.",
    reviewErrorGeneric: "Bir hata oluştu. Lütfen tekrar deneyin.",
    products: "Ürünler",
    productInformation: "Ürün Bilgileri",
    shippingReturns: "Kargo ve İade",
    material: "Malzeme",
    fastDelivery: "Hızlı Teslimat",
    fastDeliveryDescription:
      "Paketiniz 3-5 iş günü içinde teslim alım noktanıza veya evinizin rahatlığına teslim edilecektir.",
    simpleExchanges: "Kolay Değişim",
    simpleExchangesDescription:
      "Uygun değil mi? Endişelenmeyin - ürününüzü yenisiyle değiştireceğiz.",
    easyReturns: "Kolay İade",
    easyReturnsDescription:
      "Sadece ürününüzü iade edin ve paranızı geri ödeyelim. Soru sorulmaz - iadenizin sorunsuz olmasını sağlamak için elimizden geleni yapacağız.",
    addedToCart: "Sepete Eklendi",
    seller: "Satıcı",
    goToCart: "Sepete Git",
    continueShopping: "Alışverişe Devam Et",
    similarProducts: "Benzer Ürünler",
    preview: "Önizleme",
    totalAmount: "Toplam Tutar",
    fieldRequired: "{{field}} zorunludur",
    fieldMinLength: "{{field}} en az {{min}} karakter olmalıdır",
  },

  // Checkout
  checkout: {
    title: "Sipariş",
    shippingAddress: "Teslimat Adresi",
    paymentMethod: "Ödeme Yöntemi",
    orderSummary: "Sipariş Özeti",
    subtotal: "Ara Toplam",
    shipping: "Kargo",
    tax: "Vergi",
    total: "Toplam",
    placeOrder: "Siparişi Tamamla",
    backToCart: "Sepete Dön",
    processing: "İşleniyor...",
    success: {
      orderPlaced: "Siparişiniz başarıyla oluşturuldu",
      walletPayment: "Ödeme başarılı",
    },
    error: "Sipariş oluşturulurken bir hata oluştu",
    empty: {
      title: "Sepetiniz boş",
      description:
        "Görünüşe göre henüz sepetinize bir şey eklemediniz. Beğendiğiniz ürünleri bulmak için alışverişe başlayın.",
      startShopping: "Alışverişe Başla",
    },
    notices: {
      digital:
        "Sepetinizde dijital ürünler var. Bu ürünler kod olarak e-posta ile teslim edilecektir.",
      physical: "Ürün fiziksel bir üründür. Lütfen adres bilgilerini doldurun.",
      digitalOnly: "Bu fiziksel bir urundur. Teslimat adresi gereklidir.",
    },
    payment: {
      methodTitle: "Ödeme Yöntemi",
      wallet: {
        title: "Cüzdan ile öde",
        secure: "Güvenli cüzdan ödemesi",
        balance: "Kullanılabilir cüzdan bakiyeniz:",
        enterAmount: "Ödenecek Tutarı Girin",
        maxAmount: "Maks: {{amount}}",
        payNow: "Hemen Öde",
        processing: "İşleniyor...",
        noCommission: "Cüzdan ödemelerinde komisyon yok!",
      },
      creditCard: {
        title: "Kredi kartı ile öde",
      },
      bankTransfer: {
        title: "Havale/EFT ile öde",
      },
      common: {
        secure: "Paranız ve gizliliğiniz her zaman güvende",
        fast: "Hızlı ödeme, bekleme yok",
        totalPaymentWithCommission:
          "Toplam Ödeme: {{total}} (%{{commission}} komisyon uygulanır)",
      },
    },
    savedAddresses: {
      title: "Kayıtlı Adresler",
      helper:
        "Fatura ve teslimat için otomatik doldurmak üzere kayıtlı adreslerinizden birini seçin.",
      placeholder: "Kayıtlı adreslerinizden birini seçin",
      greetingPrompt:
        "Merhaba {{name}}, kayıtlı adreslerinizden birini kullanmak ister misiniz?",
    },
    billing: {
      title: "Fatura bilgileri",
      type: "Fatura Tipi",
      typePlaceholder: "Fatura tipini seçin",
      individual: "Bireysel",
      corporate: "Kurumsal",

      saveAddressLabel: "Gelecek siparişlerim için bu adresi hesabıma kaydet",
      saveAddressInfo:
        "Adres kaydetme formu açıldı! Fatura bilgileriniz dolduruldu.",
    },
    addAddressModal: {
      title: "Adresi Hesaba Kaydet",
      saveButton: "Adresi Kaydet",
    },
    fields: {
      firstName: "İsim",
      lastName: "Soyisim",
      tcNo: "T.C. Kimlik No (Opsiyonel)",
      birthDate: "Doğum Tarihi (Zorunlu)",
      phone: "Telefon",
      email: "E-posta Adresi",
      companyName: "Şirket Adı",
      taxOffice: "Vergi Dairesi",
      taxNo: "Vergi No",
      country: "Ülke",
      city: "Şehir",
      district: "İlçe",
      address: "Fatura Adresi",
      deliveryFirstName: "Teslimat Adı",
      deliveryLastName: "Teslimat Soyadı",
      deliveryPhone: "Teslimat Telefonu",
      deliveryAddress: "Teslimat Adresi",
    },
    placeholders: {
      selectCountry: "Ülke seçin",
      selectCity: "Şehir seçin",
      selectDistrict: "İlçe seçin",
    },
    delivery: {
      title: "Teslimat bilgileri",
      useBilling: "Fatura Bilgilerini Teslimat Bilgisi Olarak Kullan",
    },
    agreements: {
      title: "Sözleşmeler ve formlar",
      preContractualTitle: "Ön Bilgilendirme Formu",
      readMore: "daha fazla oku",
      distanceSellingTitle: "Mesafeli Satış Sözleşmesi",
      distanceSellingDescription:
        "Bu sözleşme, mesafeli satış işlemleri için şartları ve koşulları içerir.",
    },
    summary: {
      title: "Sipariş Özeti",
      couponNotice:
        "İndirim kuponu kullanmak için kuponu eklemek amacıyla Sepet sayfasına dönün.",
      shipping: "Kargo",
      shippingAdjustments: "Kargo Düzenlemeleri",
      tax: "Vergi",
      commission: "Komisyon",
      discount: "İndirim",
      subtotal: "Ara Toplam",
      walletPaymentAmount: "Cüzdan Ödeme Tutarı",
      remainingToPay: "Ödenecek Kalan",
      totalAmount: "Toplam Tutar",
      terms:
        "Şartları okudum ve kabul ediyorum. Sipariş güncellemeleri hakkında SMS almak istiyorum.",
      completing: "Tamamlanıyor...",
      completeCheckout: "Siparişi Tamamla",
      securePayment: "Güvenli ödeme",
      enterCoupon: "Kupon kodu girin",
      apply: "Uygula",
    },
    errors: {
      requiredFields: "Lütfen zorunlu alanları doldurun: {{fields}}",
      selectCityDistrict: "Lütfen şehir ve ilçe seçin",
      billingAddressMissing: "Lütfen fatura adresini (ülke, adres) tamamlayın",
      deliveryInfoMissing: "Lütfen teslimat bilgilerini tamamlayın: {{fields}}",
      deliveryCityDistrictMissing: "Teslimat için lütfen şehir ve ilçe seçin",
      processing: "Ödeme işlenirken bir hata oluştu",
      unknown: "Bilinmeyen bir hata oluştu",
      customerBalanceMissing: "Müşteri bakiyesi bulunamadı",
      amountExceeds: "Tutar {{amount}} değerini aşamaz",
      insufficientBalance: "Yetersiz bakiye",
      agreeToTermsRequired:
        "Ödeme yapmak için şartları ve koşulları kabul etmeniz gerekmektedir.",
    },
  },

  // Payment success page
  paymentSuccess: {
    loadingOrderDetails: "Sipariş detayları yükleniyor...",
    depositSuccessful: "Yükleme başarılı!",
    paymentSuccess: "Ödeme başarılı!",
    productImage: "Ürün görseli",
    seller: "Satıcı",
    orderSummary: "Sipariş Özeti",
    subtotal: "Ara Toplam",
    discount: "İndirim",
    totalPaid: "Toplam Ödenen",
    remainingToPay: "Kalan Ödeme",
    refresh: "Yenile",
    goToWallet: "Cüzdana Git",
    close: "Kapat",
  },

  // Order success page
  orderSuccess: {
    eyebrow: "Sipariş alındı",
    title: "Siparişiniz başarıyla tarafımıza ulaştı",
    description:
      "Müşteri temsilcimiz sipariş detaylarını kontrol ettikten sonra en kısa sürede sizinle iletişime geçecektir.",
    orderNumber: "Sipariş No:",
    contactLabel: "İrtibat numarası",
    homeButton: "Ana sayfaya dön",
    continueShopping: "Alışverişe devam et",
  },

  // Wallet
  wallet: {
    tabs: {
      wallets: "Cüzdanlar",
      deposit: "Bakiye Yükle",
      transactions: "Cüzdan İşlemleri",
      withdrawals: "Çekimler",
      withdrawalTransactions: "Çekim İşlemleri",
    },
    load: {
      title: "Bakiye Yükle",
      subtitle:
        "Cüzdanınıza kredi ekleyerek sınırsız alışverişi şimdi keşfedin.",
      error: "Ödeme ağ geçitleri yüklenemedi.",
      creditTab: "Kredi Kartı",
      bankTab: "Banka Transferi",
      enterAmount: "Tutar Girin",
      proceed: "Ödemeye geç",
      totalWithCommission:
        "Toplam Ödeme: {{total}} (%{{commission}} komisyon uygulanır)",
      commissionApplied: "(%{{commission}} komisyon uygulanır)",
      amountTransferred: "Hesabınıza Aktarılacak Tutar: {{amount}}",
      errorMessage: "Hata mesajı: {{message}}",
      goToIdVerification: "Kimlik Doğrulama sayfasına git",
    },
    balance: {
      transferTitle: "Bakiye transferi",
      transferDesc:
        "Bakiyenizi arkadaşınıza veya başka bir hesabınıza gönderin.",
      targetEmail: "Hedef hesap e-posta adresi",
      transferAmount: "Transfer tutarı",
      save: "Kaydet",
    },
    transactions: {
      title: "Cüzdan işlemleri",
      loading: "Yükleniyor...",
      error: "İşlemler yüklenemedi.",
      id: "ID",
      balanceType: "Bakiye Tipi",
      transaction: "İşlem",
      amount: "Tutar",
      balance: "Bakiye",
      reason: "Sebep",
      createdAt: "Oluşturulma",
      empty: "İşlem bulunamadı.",
      balanceTypes: {
        inAppBalance: "Uygulama İçi Bakiye",
        withdrawalBalance: "Çekim Bakiyesi",
        blockedBalance: "Bloke Bakiye",
        bonusBalance: "Bonus Bakiye",
      },
      transactionTypes: {
        payment: "Ödeme",
        addBalance: "Bakiye ekleme",
        depositRelease: "Yatırım serbest bırakma",
        addInAppBalance: "Uygulama İçi Bakiye Ekleme",
        refund: "İade",
      },
    },
    withdrawals: {
      title: "Transfer ve İadeler",
      subtitle: "Cüzdanınızdaki nakiti ödeme yaptığınız hesaba aktarın.",
      limit: "Çekilecek tutar {{amount}} TRY ile sınırlıdır",
      addNew: "Yeni bilgi ekle",
      useSaved: "Kayıtlı bilgileri kullan",
      success: "Çekim talebi başarıyla oluşturuldu",
      invalidAmount: "Lütfen geçerli ve pozitif bir tutar girin",
      exceedsBalance:
        "Talep ettiğiniz tutar mevcut bakiyenizden büyük. Mevcut bakiyeniz {{balance}} TRY",
      newData: {
        important: "Önemli Duyuru:",
        transferInfo:
          "Sitemizde satış yaparak kazandığınız bakiyeyi banka hesabınıza aktarabilirsiniz.",
        verifyPrefix:
          "Çekim talebi göndermeden önce lütfen kimlik bilgilerinizi",
        userInfoLink: "'Kullanıcı Bilgilerim'",
        verifySuffix: " bölümünde doğrulayın.",
        processingHours:
          "Bakiye çekim talepleri 09:00 ile 04:00 arasında işlenir.",
        minAmount:
          "30 TL ve üzerindeki bakiyeler için nakit çekim talebinde bulunabilirsiniz.",
        feeInfo:
          "Havale/EFT işlemleri için tüm bankalarda talep edilen tutardan 5 TL kesinti yapılır.",
        iban: "IBAN",
        accountName: "Hesap Adı",
        phoneNumber: "Telefon Numarası",
        amount: "Tutar",
        amountTransfer: "Hesaba aktarılacak tutar: {{amount}} TL",
        fastPayment: "Hızlı ödeme",
        saveInfos: "Bilgilerimi kaydet",
        createRequest: "Talep oluştur",
      },
    },
    withdrawalsTransactions: {
      title: "Bakiye çekim talepleri",
      loading: "Yükleniyor...",
      error: "İşlemler yüklenemedi.",
      type: "Tip",
      fast: "Hızlı",
      normal: "Normal",
      accountInfo: "Hesap Bilgisi",
      amount: "Tutar",
      commission: "Komisyon",
      createdAt: "Oluşturulma",
      status: "Durum",
      detailsTitle: "Çekim Detayları",
      bank: "Banka",
      account: "Hesap",
      iban: "IBAN",
      reason: "Sebep",
      cancel: "İptal",
      close: "Kapat",
      empty: "İşlem bulunamadı",
    },
  },

  // Order
  order: {
    title: "Siparişlerim",
    orderNumber: "Sipariş No",
    date: "Tarih",
    status: "Durum",
    total: "Toplam",
    viewDetails: "Detayları Görüntüle",
    tracking: "Kargo Takibi",
    noOrders: "Henüz siparişiniz yok",
    pending: "Beklemede",
    processing: "İşleniyor",
    shipped: "Kargoya Verildi",
    delivered: "Teslim Edildi",
    cancelled: "İptal Edildi",
  },

  // Order Details (single order page)
  orderDetails: {
    backToOverview: "Genel bakışa dön",
    title: "Sipariş detayları",
    confirmationSent: "Sipariş onay detaylarını şu adrese gönderdik:",
    orderDate: "Sipariş tarihi:",
    orderNumber: "Sipariş numarası:",
    orderStatus: "Sipariş durumu:",
    orderSummary: "Sipariş Özeti",
    subtotal: "Ara Toplam",
    discount: "İndirim",
    totalPaid: "Toplam Ödenen",
    refunded: "İade Edilen",
    payment: "Ödeme",
    paymentMethod: "Ödeme yöntemi",
    paymentDetails: "Ödeme detayları",
    status: "Durum",
    paidAt: "tarihinde ödendi",
    wallet: "Cüzdan",
    card: "Kart",
    paymentLabel: "Ödeme",
    needHelp: "Yardıma mı ihtiyacınız var?",
    contact: "İletişim",
    returnsExchanges: "İade ve Değişim",
    code: "Kod:",
    codeCopiedToClipboard: "Kod panoya kopyalandı",
    refund: "İade:",
    price: "Fiyat:",
    youSave: "Tasarruf",
  },

  // Order Tracking (guest/logged-in track by order number)
  orderTracking: {
    title: "Sipariş Takibi",
    subtitle: "Sipariş durumunu öğrenmek için sipariş numaranızı girin.",
    enterOrderNumber: "Lütfen sipariş numaranızı girin.",
    orderNotFound:
      "Sipariş bulunamadı. Lütfen sipariş numaranızı kontrol edin.",
    searchError:
      "Siparişiniz aranırken bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
    howItWorks: "Sipariş Takibi Nasıl Çalışır",
    step1Title: "1. Sipariş Numarasını Girin",
    step1Description: "E-postanıza gönderilen sipariş numarasını kullanın.",
    step2Title: "2. Durumu Görüntüleyin",
    step2Description: "Siparişinizin güncel durumunu ve detaylarını görün.",
    step3Title: "3. İlerlemeyi Takip Edin",
    step3Description: "Teslimata kadar siparişinizi her adımda takip edin.",
    inputPlaceholder: "Sipariş numaranızı girin",
    reset: "Sıfırla",
    loadingTrack: "Yükleniyor...",
  },

  // Search
  search: {
    placeholder: "Ürün ara...",
    noResults: "Sonuç bulunamadı",
    results: "Sonuçlar",
    filters: "Filtreler",
    sort: "Sırala",
    clear: "Temizle",
    resultsTitle: "Arama sonuçları",
    searching: "Aranıyor...",
    emptyStateTitle: "Aramaya başlayın",
    emptyStateHint: "Ürün ve kategorilerde aramak için en az 3 karakter yazın.",
    noResultsForQuery:
      '"{{query}}" için sonuç bulunamadı. Farklı anahtar kelimeler deneyin.',
    resultsCount: "{{count}} sonuç bulundu",
    priceUnavailable: "Fiyat bilgisi yok",
    resultTypeCategory: "Kategori",
    resultTypeProduct: "Ürün",
    countrySearchPlaceholder: "Ülke ara...",
    countryNotFound: "Ülke bulunamadı.",
  },

  // Category
  category: {
    all: "Tümü",
    noProducts: "Bu kategoride ürün bulunamadı",
    filters: "Filtreler",
    sort: "Sırala",
  },

  // Footer
  contactBanner: {
    contactUs: "Bize Ulaşın",
    contactUsDescription: "Sorularınız için bizimle iletişime geçin",
    followUs: "Bizi takip edin",
    socialMediaAccounts: "Sosyal medya hesaplarımız",
  },

  // Footer
  footer: {
    about: "Hakkımızda",
    contact: "İletişim",
    terms: "Kullanım Koşulları",
    privacy: "Gizlilik Politikası",
    support: "Destek",
    newsletter: "Bülten",
    subscribe: "Abone Ol",
    popularCategories: "Popüler Kategoriler",
    corporate: "Kurumsal",
    agreements: "Sözleşmeler",
    member: "Üye",
    taxOfficeNumber: "Vergi Dairesi / No",
    company: "Şirket",
    address: "Adres",
    customerSupport: "Müşteri desteği",
    defaultAddress: "LEFKOŞA / KIBRIS",
    copyright: "© {{year}} 101yapi. Tum haklari saklidir.",
  },

  // Errors
  error: {
    general: "Bir hata oluştu",
    network: "Bağlantı hatası",
    notFound: "Sayfa bulunamadı",
    unauthorized: "Yetkiniz yok",
    server: "Sunucu hatası",
    tryAgain: "Tekrar Deneyin",
  },

  // Sign In
  signIn: {
    title: "Giriş Yap",
    description: "101yapi hesabınıza giriş yapın.",
    email: "E-Posta",
    emailPlaceholder: "E-posta adresinizi girin",
    password: "Şifre",
    passwordPlaceholder: "Şifrenizi girin",
    loginButton: "GİRİŞ YAP",
    registerButton: "KAYIT OL",
    forgotPassword: "Şifremi Unuttum?",
    disclosureText: "Aydınlatma Metnini Okumak İçin Tıklayınız!",
    or: "VEYA",
    infoTitleLine1: "Giriş Yaparak",
    infoTitleLine2: "Ayrıcalıklardan",
    infoTitleLine3: "Faydalanmaya Başla",
  },

  // Sign Up
  signUp: {
    title: "Kayıt Ol",
    description: "Yeni bir 101yapi hesabı oluşturun.",
    firstName: "Ad",
    firstNamePlaceholder: "Adınızı girin",
    lastName: "Soyad",
    lastNamePlaceholder: "Soyadınızı girin",
    phone: "Telefon Numaranız",
    phonePlaceholder: "Telefon numaranızı girin",
    email: "E-Posta",
    emailPlaceholder: "E-posta adresinizi girin",
    password: "Şifre",
    passwordPlaceholder: "Şifrenizi girin",
    kvkkText: "Kvkk Metnini",
    kvkkRead: "okudum",
    termsText: "Üyelik Sözleşmesini",
    termsRead: "okudum",
    registerButton: "KAYIT OL",
    processing: "İŞLEM YAPILIYOR...",
    disclosureText: "Aydınlatma Metnini Okumak İçin Tıklayınız!",
    firstNameRequired: "Ad zorunludur",
    lastNameRequired: "Soyad zorunludur",
    emailInvalid: "Geçersiz e-posta adresi",
    passwordMinLength: "Şifre en az 8 karakter olmalıdır.",
    phoneInvalid: "Türk telefon numarası 12 haneli olmalıdır",
    phoneAlreadyInUse: "Bu telefon numarası zaten kullanılıyor",
    kvkkRequired: "KVKK'yı kabul etmelisiniz",
    termsRequired: "Kullanım Koşullarını kabul etmelisiniz",
    registrationFailed: "Kayıt başarısız oldu",
    infoTitleLine1: "Kayıt Olarak",
    infoTitleLine2: "Ayrıcalıklardan",
    infoTitleLine3: "Faydalanmaya Başla",
    haveAccount: "Hesabınız var mı, hemen",
    signInLink: "GİRİŞ YAPIN!",
    countryCode: "Ülke Kodu",
  },

  // Forgot Password
  forgotPassword: {
    title: "Şifremi Unuttum",
    description: "Şifrenizi sıfırlamak için e-posta adresinizi girin.",
    step1Description: "E-posta adresinize doğrulama kodu göndereceğiz",
    step2Description: "E-posta adresinize gönderilen 6 haneli kodu girin",
    step3Description: "Hesabınız için yeni bir şifre belirleyin",
    email: "E-Posta Adresi",
    emailPlaceholder: "ornek@email.com",
    verificationCode: "6 Haneli Doğrulama Kodu",
    codeSentTo: "Kodu {{email}} adresine gönderdik",
    enterEmailAndCode: "E-posta adresinizi girin ve doğrulama kodunuzu giriniz",
    newPassword: "Yeni Şifre",
    newPasswordPlaceholder: "En az 6 karakter",
    confirmPassword: "Yeni Şifre (Tekrar)",
    confirmPasswordPlaceholder: "Şifrenizi tekrar girin",
    sendCodeButton: "Doğrulama Kodu Gönder",
    verifyButton: "Kodu Doğrula",
    updatePasswordButton: "Şifreyi Güncelle",
    sending: "Gönderiliyor...",
    verifying: "Doğrulanıyor...",
    updating: "Güncelleniyor...",
    passwordsMatch: "✓ Şifreler eşleşiyor",
    passwordsNotMatch: "✗ Şifreler eşleşmiyor",
    codeSentSuccess: "Doğrulama kodu e-posta adresinize gönderildi",
    codeVerifiedSuccess: "Kod başarıyla doğrulandı",
    passwordUpdatedSuccess:
      "Şifreniz başarıyla güncellendi. Giriş sayfasına yönlendiriliyorsunuz...",
    passwordsNotMatchError: "Şifreler eşleşmiyor",
    passwordMinLengthError: "Şifre en az 6 karakter olmalıdır",
    requestFailed: "İstek başarısız oldu",
    verificationFailed: "Doğrulama başarısız",
    updateFailed: "Şifre güncelleme başarısız",
  },

  // ID Verification
  idVerification: {
    title: "Kimlik Doğrulama",
    description: "Kimlik doğrulama yükleme sayfası",
  },

  // Impersonate
  impersonate: {
    accessDenied: "Erişim Reddedildi",
    noTokenProvided:
      "URL'de kimlik doğrulama token'ı sağlanmadı. Lütfen geçerli bir kimliğe bürünme bağlantısı kullanın.",
    expectedUrlFormat: "Beklenen URL formatı:",
    returnToPreviousPage: "Önceki Sayfaya Dön",
    impersonationSuccessful: "Kimliğe Bürünme Başarılı",
    authenticatedAsUser:
      "Artık hedef kullanıcı olarak kimlik doğrulaması yaptınız. Dashboard'a yönlendiriliyor...",
    redirectingToDashboard: "Kullanıcı dashboard'ına yönlendiriliyor...",
    fullAccessWarning:
      "Artık bu kullanıcının hesabına tam erişiminiz var. Tüm işlemler güvenlik amacıyla kaydedilir.",
    authenticationFailed: "Kimlik Doğrulama Başarısız",
    unableToComplete: "Kimliğe bürünme işlemi tamamlanamadı.",
    whatYouCanDo: "Yapabilecekleriniz:",
    requestNewLink: "Yeni bir kimliğe bürünme bağlantısı isteyin",
    checkExpired: "Bağlantının süresi dolmuş mu kontrol edin",
    contactAdmin: "Sistem yöneticinizle iletişime geçin",
    goBack: "Geri Dön",
    authenticating: "Kimlik Doğrulama",
    processingToken:
      "Kimlik doğrulama token'ınızı işliyor ve kullanıcı oturumu oluşturuyoruz.",
    allActivitiesLogged:
      "Kimlik doğrulama token'ı işleniyor. Tüm kimliğe bürünme faaliyetleri kaydedilir ve izlenir.",
  },

  // Dashboard
  dashboard: {
    title: "Hesap",
    description: "Hesap aktivitenizin genel bakışı.",
    overview: "Genel Bakış",
    orders: "Siparişler",
    ordersDescription:
      "Önceki siparişlerinizi ve durumlarını görüntüleyin. Gerekirse siparişleriniz için iade veya değişim oluşturabilirsiniz.",
  },

  // Navbar
  navbar: {
    loadBalance: "Bakiye Yükle",
    hiddenBalance: "*** TL",
    overview: "Genel Bakış",
    profile: "Profil",
    wallet: "Cüzdan",
    bankDetails: "Banka Detayları",
    lottery: "Kampanya",
    address: "Adres",
    orders: "Siparişler",
    streamerSettings: "Bayi Ayarları",
    referrals: "Referanslar",
    referralTitle: "Referanslar",
    referralDescription: "Ödül kazanmak için referans linkinizi paylaşın.",
    referralAnalytics: "Referans Analitiği",
    referralDailyGains: "Günlük Kazançlar",
    referralWeeklyGains: "Haftalık Kazançlar",
    referralTotalGains: "Toplam Kazanç",
    referralTotalUsers: "Toplam Referanslı Kullanıcı",
    referralCharts: "Referans Kazanç Grafikleri",
    referralDailyLabel: "Günlük Kazançlar",
    referralMonthlyLabel: "Aylık Kazançlar",
    referralTooltipGains: "Kazanç",
    referralTooltipCount: "Referans Sayısı",
    streamerMySettings: "Ayarlarım",
    streamerDonations: "Bağışlar",
    streamerSubmitInfo: "Bayi Bilgisi Gönder",
    streamerPending: "Bayi başvurunuz inceleniyor.",
    streamerConnectingTitle: "Tedarikci Baglantisi Kuruluyor",
    streamerConnectingDescription: "Baglanti isleniyor...",
    logout: "Çıkış Yap",
    loading: "Yükleniyor...",
  },

  // Navigation Items
  navItems: {
    allGames: "TUM URUNLER",
    mobileGames: "EL ALETLERI",
    gameGold: "HIRDAVAT",
    loadId: "CIMENTO",
    subscriptions: "ABONELİKLER",
    giftCards: "YAPI MALZEMELERI",
    streamers: "KURUMSAL",
  },

  // Guest Checkout
  guestCheckout: {
    title: "Misafir Ödemesi",
    description:
      "Hesap oluşturmadan hızlı ve güvenli bir şekilde satın alımınızı tamamlayın",
    fastPurchaseInfo:
      'Hızlı satın alma sistemi ile <b>Kredi Kartı, Banka Kartı, Maaş - Hesap Kartı ve Tüm Kartlar</b> ile ödeme yapabilirsiniz.<br />Ücretsiz <b>Banka Transferi/EFT</b> gibi daha fazla ödeme seçeneği görmek için <a href="/account/sign-in" class="text-blue-300 underline">giriş yapın</a> veya <a href="/account/sign-up" class="font-bold text-blue-300 underline">kayıt olun</a>.<br />Sipariş bilgileriniz e-posta adresinize gönderilecektir.',
    physicalProductNotice:
      "Ürün fiziksel bir üründür. Lütfen adres bilgilerini doldurun.",
    error: "Hata",
    billingInformation: "Fatura Bilgileri",
    billingType: "Fatura Tipi",
    selectBillingType: "Fatura tipini seçin",
    individual: "Bireysel",
    corporate: "Kurumsal",

    firstName: "Ad",
    lastName: "Soyad",
    nationalIdOptional: "TC Kimlik No (İsteğe Bağlı)",
    dateOfBirth: "Doğum Tarihi",
    phone: "Telefon",
    emailAddress: "E-Posta Adresi",
    companyName: "Şirket Adı",
    taxOffice: "Vergi Dairesi",
    taxNo: "Vergi No",
    country: "Ülke",
    selectCountry: "Ülke seçin",
    city: "Şehir",
    selectCity: "Şehir seçin",
    district: "İlçe",
    selectDistrict: "İlçe seçin",
    billingAddress: "Fatura Adresi",
    deliveryInformation: "Teslimat Bilgileri",
    useBillingAsDelivery: "Fatura Bilgilerini Teslimat Bilgileri Olarak Kullan",
    deliveryAddress: "Teslimat Adresi",
    invoiceInfo:
      "Bu bilgiler fatura düzenleme için kullanılacaktır. E-Arşiv faturadır ve yalnızca e-posta adresinize gönderilecektir.",
    orderSummary: "Sipariş Özeti",
    digitalProductsNotice:
      "Urunler adresinize guvenli kargo ile teslim edilecektir.",
    quantity: "Miktar",
    playerId: "Musteri Notu",
    noExtraInfo: "Ekstra bilgi yok",
    noProductsInCart: "Sepetinizde ürün bulunmuyor",
    commission: "Komisyon",
    shipping: "Kargo",
    free: "Ücretsiz",
    discount: "İndirim",
    subtotal: "Ara Toplam",
    totalAmount: "Toplam Tutar",
    amountToBePaid: "Ödenecek Tutar",
    processing: "İşleniyor...",
    selectPaymentMethod: "Ödeme yöntemi seçin",
    completePurchase: "Satın Alımı Tamamla",
    securePayment: "Ödeme işlemi güvenli SSL bağlantısı ile korunmaktadır",
    selectPaymentMethodError: "Lütfen bir ödeme yöntemi seçin",
    fillRequiredFields: "Lütfen zorunlu alanları doldurun",
    fillRequiredBillingFields:
      "Lütfen Adres, Telefon ve E-Posta dahil tüm zorunlu fatura alanlarını doldurun",
    fillFirstNameLastName: "Lütfen adınızı ve soyadınızı girin",
    paymentFailed: "Ödeme başarısız oldu. Lütfen tekrar deneyin.",
    paymentProcessingFailed: "Ödeme işlemi başarısız oldu",
    loadingPaymentGateways: "Ödeme ağ geçitleri yükleniyor...",
    failedToLoadGateways: "Ödeme ağ geçitleri yüklenemedi.",
    selectPaymentMethodTitle: "Ödeme Yöntemi Seçin",
    commissionLabel: "Komisyon",
  },

  // Account Components
  account: {
    // General
    title: "Hesabım",
    payments: "Ödeme Yöntemlerim",
    settings: "Ayarlar",
    logout: "Çıkış Yap",
    login: "Giriş Yap",
    register: "Kayıt Ol",
    forgotPassword: "Şifremi Unuttum",
    resetPassword: "Şifre Sıfırla",

    // Account Info
    edit: "Düzenle",
    cancel: "İptal",
    saveChanges: "Değişiklikleri Kaydet",
    updatedSuccessfully: "{{label}} başarıyla güncellendi",
    errorOccurred: "Bir hata oluştu, lütfen tekrar deneyin",

    // Account Nav
    dashboard: "Dashboard",
    profile: "Profil",
    bankDetails: "Banka Detayları",
    lottery: "Kampanya",
    wallet: "Cüzdan",
    addresses: "Adresler",
    orders: "Siparişler",
    referrals: "Referanslar",
    streamerSettings: "Bayi Ayarları",
    logOut: "Çıkış Yap",
    account: "Hesap",
    referralTitle: "Referanslar",
    referralDescription: "Ödül kazanmak için referans linkinizi paylaşın.",
    referralAnalytics: "Referans Analitiği",
    referralDailyGains: "Günlük Kazançlar",
    referralWeeklyGains: "Haftalık Kazançlar",
    referralTotalGains: "Toplam Kazanç",
    referralTotalUsers: "Toplam Referanslı Kullanıcı",
    referralCharts: "Referans Kazanç Grafikleri",
    referralDailyLabel: "Günlük Kazançlar",
    referralMonthlyLabel: "Aylık Kazançlar",
    referralTooltipGains: "Kazanç",
    referralTooltipCount: "Referans Sayısı",
    streamerMySettings: "Ayarlarım",
    streamerDonations: "Bağışlar",
    streamerSubmitInfo: "Bayi Bilgisi Gönder",
    streamerPending: "Bayi başvurunuz inceleniyor.",
    streamerConnectingTitle: "Tedarikci Baglantisi Kuruluyor",
    streamerConnectingDescription: "Baglanti isleniyor...",

    // Profile Components
    phone: "Telefon",
    phonePlaceholder: "Telefon numaranızı girin",
    phoneUpdateFailed: "Telefon numarası güncellenemedi",
    phoneUpdateSuccess: "Telefon numarası başarıyla güncellendi",
    password: "Şifre",
    passwordNotShown: "Güvenlik nedeniyle şifre gösterilmiyor",
    oldPassword: "Eski şifre",
    newPassword: "Yeni şifre",
    confirmPassword: "Şifreyi onayla",
    name: "İsim",
    firstName: "Ad",
    lastName: "Soyad",
    nameUpdateFailed: "İsim güncellenemedi",
    nameUpdateSuccess: "İsim başarıyla güncellendi",
    profileImage: "Profil Resmi",
    profileImageUpdateFailed: "Profil resmi güncellenemedi",
    addProfilePicture: "Profil resmi ekle",
    email: "E-Posta",
    emailUpdateFailed: "E-posta güncellenemedi",
    billingAddress: "Fatura Adresi",
    noBillingAddress: "Fatura adresi yok",
    company: "Şirket",
    address: "Adres",
    apartmentSuite: "Daire, suite, vb.",
    postalCode: "Posta Kodu",
    city: "Şehir",
    province: "İl",
    country: "Ülke",
    selectCountry: "Ülke seçin",
    selectCity: "Şehir seçin",
    selectDistrict: "İlçe seçin",
    billingAddressUpdateFailed: "Fatura adresi güncellenemedi",

    // Referral Card
    yourReferralLink: "Referans Linkiniz",
    howItWorks: "Nasıl çalışır:",
    shareReferralLink: "Benzersiz referans linkinizi paylaşın",
    customersSignUp: "Müşteriler linkinizi kullanarak kayıt olur",
    earnRewards: "Müşterinin işlemlerine göre ödül kazanırsınız",
    referralLinkCopied: "Referans linki panoya kopyalandı",
    failedToCopyLink: "Link kopyalanamadı",

    // Order Components
    orderId: "Sipariş ID",
    date: "Tarih",
    total: "Toplam",
    item: "Ürün",
    items: "Ürünler",
    seeDetails: "Detayları Gör",
    qty: "Adet",
    more: "daha fazla",
    noOrdersYet: "Henüz siparişiniz yok, bunu değiştirelim",
    continueShopping: "Alışverişe Devam Et",
    datePlaced: "Sipariş tarihi",
    orderNumber: "Sipariş numarası",
    totalAmount: "Toplam tutar",
    noRecentOrders: "Son sipariş yok",
    streamerSubmitInfoTitle: "Bayi Bilgisi Gönder",
    streamerSubmitInfoDescription:
      "Bayi başvurunuzu tamamlamak için aşağıdaki bilgileri doldurun. * işaretli alanlar zorunludur.",
    streamerFormStepInfo: "📊 1. Bayi Bilgisi",
    streamerFormStepSocial: "🌐 2. Sosyal Medya Linkleri",
    streamerFormStepCounter: "Adım {current} / {total}",
    streamerUsernameLabel: "Bayi Kullanıcı Adı",
    streamerUsernamePlaceholder: "Bayi kullanıcı adınızı girin",
    streamerStreamUrlLabel: "Yayın URL",
    streamerStreamUrlPlaceholder: "https://www.twitch.tv/",
    streamerProfilePathLabel: "Bayi Profil Yolu",
    streamerProfilePathPlaceholder: "Profil yolunu girin",
    streamerUsernameRequired: "Bayi kullanıcı adı zorunludur",
    streamerStreamUrlRequired: "Yayın URL zorunludur",
    streamerMpathRequired: "Profil yolu zorunludur",
    streamerFormCheckInputs: "Lütfen form alanlarını kontrol edin",
    streamerFormSubmittedSuccessfully: "Bayi bilgisi başarıyla gönderildi",
    streamerFormSubmitFailed: "Bayi bilgisi gönderilemedi",
    streamerSubmitInfoButton: "Bayi Bilgisini Gönder",
    socialTwitch: "Twitch",
    socialYoutube: "YouTube",
    socialDiscord: "Discord",
    socialInstagram: "Instagram",
    socialFacebook: "Facebook",
    socialTwitterX: "Twitter/X",
    socialNimo: "Nimo",
    socialDlive: "DLive",
    socialKick: "Kick",
    socialTiktok: "TikTok",

    // Overview Components
    hello: "Merhaba",
    signedInAs: "Giriş yapıldı:",
    profileTab: "Profil",
    followersTab: "Takipçiler",
    friendsTab: "Arkadaşlar",
    galleryTab: "Galeri",
    completed: "Tamamlandı",
    takeAction: "Harekete Geç",
    totalBalances: "Toplam Bakiyeler",
    about: "Hakkında",
    noPostsYet: "Henüz gönderi yok",
    shareThinking: "Düşüncelerinizi paylaşın...",
    imageVideo: "Resim/Video",
    post: "Gönder",
    likes: "beğeni",
    writeComment: "Yorum yazın...",
    gallery: "Galeri",
    followers: "Takipçiler",
    follow: "Takip Et",
    followed: "Takip Ediliyor",
    yourProfileIsComplete: "Profiliniz tamamlandı!",
    signUpOrLogin:
      "Profilinizi tamamlamaya başlamak için kayıt olun veya giriş yapın.",
    addEmailAddress: "E-posta adresinizi ekleyin.",
    completeNameDetails: "İsim bilgilerinizi tamamlayın.",
    addPhoneNumber: "Telefon numarası ekleyin.",
    setDefaultBillingAddress: "Varsayılan fatura adresi belirleyin.",

    // Address Components
    newAddress: "Yeni Adres",
    addAddress: "Adres Ekle",
    editAddress: "Adresi Düzenle",
    addressName: "Adres Adı",
    defaultShipping: "Varsayılan Teslimat",
    defaultBilling: "Varsayılan Fatura",
    remove: "Kaldır",
    districtState: "İlçe / Eyalet",
    provinceDistrict: "İl / İlçe",

    // Bank Details Components
    newBankDetails: "Yeni Banka Detayları",
    addBankDetails: "Banka Detayları Ekle",
    editBankDetails: "Banka Detaylarını Düzenle",
    phoneNumber: "Telefon Numarası",
    iban: "IBAN",
    accountName: "Hesap Adı",
    bankName: "Banka Adı",

    // Lottery Components
    lotteries: "Çekilişler",
    activeLotteries: "Aktif Çekilişler",
    completedLotteries: "Tamamlanan Çekilişler",
    allLotteries: "Tüm Çekilişler",
    createLottery: "Çekiliş Oluştur",
    myLotteries: "Çekilişlerim",
    attendedLotteries: "Katıldığım Çekilişler",
    searchLotteries: "Çekilişlerde ara...",
    createNewLottery: "Yeni Kampanya Oluştur",
    fillInfoBelow:
      "Yeni bir piyango oluşturmak için aşağıdaki bilgileri doldurun. * ile işaretli tüm alanlar zorunludur.",
    basicInfo: "Temel Bilgiler",
    prizeDetails: "Ödül Detayları",
    step: "Adım",
    of: "/",
    lotteryTitle: "Kampanya Başlığı",
    enterLotteryTitle: "Kampanya başlığını girin",
    enterTaskLinks: "Görev linklerini satır satır girin",
    lotteryEndDate: "Kampanya Bitiş Tarihi",
    maxParticipants: "Maksimum Katılımcı",
    ifLeftEmpty: "(Boş bırakılırsa 9999999 olarak ayarlanacaktır)",
    lotteryType: "Kampanya Tipi",
    selectLotteryType: "Kampanya tipini seçin",
    product: "Ürün",
    balance: "Bakiye",
    next: "İleri",
    selectProduct: "Ürün Seç",
    winnerCount: "Kazanan Sayısı",
    available: "Mevcut",
    alreadyUsed: "zaten kullanıldı",
    add: "Ekle",
    submit: "Gönder",
    balanceAmount: "Bakiye Tutarı",
    lotteryCreatedSuccess: "Kampanya başarıyla oluşturuldu",
    failedToCreateLottery: "Kampanya oluşturulamadı",
    pleaseCheckFormInputs: "Lütfen form girişlerinizi kontrol edin",
    pleaseSelectProduct: "Lütfen bir ürün seçin ve kazanan sayısını girin",
    winnerCountAtLeast1: "Kazanan sayısı en az 1 olmalıdır",
    winnerCountExceedStock: "Kazanan sayısı kalan stoku aşamaz",
    titleRequired: "Başlık zorunludur",
    lotteryEndDateMustBeFuture: "Kampanya bitiş tarihi gelecekte olmalıdır",
    giftsRequired: "Hediyeler zorunludur",

    // Delete Account
    deleteMyAccount: "Hesabımı Sil",
    canDeletePermanently: "Hesabınızı kalıcı olarak silebilirsiniz",
    delete: "Sil",
    confirm: "Onay",
    emailVerification: "E-Posta",
    areYouSureDelete: "Hesabınızı silmek istediğinize emin misiniz?",
    thisActionCannotBeUndone:
      "Bu işlem geri alınamaz. Tüm verileriniz kalıcı olarak silinecektir.",
    yesContinue: "Evet, Devam Et",
    verifyEmailAddress: "Email Adresinizi Doğrulayın",
    enterEmailToDelete: "Hesabınızı silmek için email adresinizi giriniz:",
    emailNotMatching:
      "Email adresi eşleşmiyor. Lütfen doğru email adresinizi giriniz.",
    emailVerified: "Email adresi doğrulandı",
    back: "Geri",
    deleting: "Siliniyor...",
    deleteAccount: "Hesabı Sil",
    accountDeletedSuccess: "Hesabınız başarıyla silindi",
    errorDeletingAccount: "Hesap silinirken bir hata oluştu",
  },
  variantSelectionModal: {
    title: "{{product}} için bir varyant seçin",
    addToCartTitle: "{{product}} ürününü sepete eklemek için varyant seçin",
    noImage: "Resim yok",
    noVariants: "Bu üründe varyant yok.",
    addFavorite: "Favorilere ekle",
    removeFavorite: "Favorilerden kaldır",
    favoriteAdded: "Favorilere eklendi.",
    favoriteRemoved: "Favorilerden kaldırıldı.",
    favoriteIdNotFound: "Favori ID bulunamadı.",
    unexpectedError: "Bir hata oluştu.",
  },
}
